import React from 'react';
import ModalButton from './ModalButton';

const InvalidEmailModal = ({email, closeModal})=>{
	return <div>
		<div>It doesn't look like <strong>{email}</strong> is a real email address!</div>
		<ModalButton text="Try again" onClick={closeModal} />
	</div>
}

export default InvalidEmailModal;